import React, { useEffect } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();
  const { signOut, user, loading } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login', { replace: true });
    }
  }, [loading, user, navigate]);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  if (loading || !user) {
    return null;
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Paper elevation={3} sx={{ p: 4, width: 420 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Access denied
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Your account does not have access to this area.
        </Typography>
        <Button variant="outlined" onClick={handleSignOut}>
          Sign out
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessDeniedPage;
